module.exports = __webpack_public_path__ + "img/FeatureMiniwebHaidresserExampleResizedCompressed.44723a49.png";